import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const iconColorMap = {
  'fa-th-large': '#e8f0fe',
  'fa-calendar': '#fef3e2',
  'fa-file-text-o': '#e8faf0',
  'fa-download': '#f0e8fe',
  'fa-cog': '#e8f4fe',
  'fa-upload': '#fef0e8',
  'fa-plus-circle': '#e8fef4',
  'fa-plug': '#f5e8fe',
  'fa-shield': '#e8fefe',
  'fa-toggle-on': '#fef8e8',
  'fa-credit-card': '#e8ecfe',
  'fa-id-card-o': '#fef0f0',
  'fa-file-text': '#f0f8e8',
  'fa-envelope-o': '#e8f0fa',
  'fa-power-off': '#fef0e8',
  'fa-sliders': '#f0f0f8',
  'fa-money': '#e8faf8',
  'fa-bolt': '#fef8f0',
  'fa-table': '#f0e8f8',
  'fa-calendar-check-o': '#e8f8f0',
  'fa-cogs': '#f8f0e8',
  'fa-diamond': '#f0f8fe',
  'fa-tag': '#fef0f8',
  'fa-bar-chart': '#e8f5fe',
  'fa-gear': '#f5f5f5',
  'fa-file-o': '#e8f0fe',
};

const renderNavContent = (iconClass, label) => (
  <span className="sidebar-nav-item">
    <span
      className="sidebar-nav-icon"
      style={{ backgroundColor: iconColorMap[iconClass] || '#eef2f7' }}
    >
      <i className={`fa ${iconClass}`} aria-hidden="true" />
    </span>
    <span className="sidebar-nav-label">{label}</span>
  </span>
);

const navTitle = (iconClass, label, showTooltip = false) => {
  const content = renderNavContent(iconClass, label);

  if (!showTooltip) {
    return content;
  }

  const tooltipId = `sidebar-nav-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 0, hide: 100 }}
      overlay={
        <Tooltip id={tooltipId} className="sidebar-nav-tooltip">
          {label}
        </Tooltip>
      }
    >
      {content}
    </OverlayTrigger>
  );
};

export default navTitle;
